import React, { useEffect } from 'react'
import {useNavigate, useParams} from 'react-router-dom'

export const ConexionExterna = () => {
    const {token} = useParams()
    const navigate = useNavigate();
    const test = () => {
        navigate("/conectando", {state: {token}});
        }
      useEffect(() => {
      test()
      // carga inicial (una sola vez al montar)
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [])


  return (
    <div>
    </div>
  )
}
